import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cf4c762"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "switch-container" }
const _hoisted_2 = {
  key: 1,
  class: "fa fa-lock lock-icon"
}

import { computed } from 'vue';
import { DxSwitch } from 'devextreme-vue/switch';


export default /*#__PURE__*/_defineComponent({
  __name: 'switch-toggle',
  props: {
    /** 
     * The boolean, or number value used with `v-model` to control the visibility or state of a modal or component.
     * @type [number, boolean]
     * @required
     */
    modelValue: {
        type: [Number, Boolean],
        required: true
    },
    /** 
     * Determines whether the control is read only.
     * @type {boolean}
     * @default true
     */
    readOnly: {
        type: Boolean,
        default: true
    },
    /** 
    * The label displayed for the control.
    * @type {String}
    * @default ''
    */
    label: {
        type: String,
        default: ''
    },
    /** 
     * The margin to bottom of component (for CSS styling).
     * @type {string}
     * @default '0.75rem'
     */
    marginBottom: {
        type: String,
        default: '0.75rem'
    },
    /** 
     * The width to label (for CSS styling).
     * @type {string}
     * @default 'fit-content'
     */
    labelWidth: {
        type: String,
        default: 'fit-content'
    },
    /** 
     * Determines whether the label is required to change position.
     * @type {boolean}
     * @default false
     */
    isLabelPositionToEnd: {
        type: Boolean,
        default: false
    },
    /** 
 * Determines whether the lock icon should be displayed.
 * @type {boolean}
 * @default false
 */
    displayLockIcon: {
        type: Boolean,
        default: false
    },
},
  emits: ['update:modelValue', 'onVaueChange'],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "1717678a": (props.marginBottom),
  "7c050b18": (props.labelWidth)
}))





const switchModel = computed({
    get: () => props.modelValue,
    set: (value: boolean | number) => emit('update:modelValue', value)
});

const onChange = (e: any) => {
    // Double not notation used to ensure a boolean value instead of a numeric conversion
    let newValue: boolean | number = !!e.value;

    // To avoid errors in parent components, ensure the new value matches the type of the original modelValue 
    if (typeof props.modelValue === 'number') {
        newValue = e.value ? 1 : 0
    }

    switchModel.value = newValue;
    emit('onVaueChange', newValue);
};

// As the DxSwitch component requires a boolean, we must ensure the modelValue passed is converted to a boolean
const dxSwitchValue = computed(() => !!switchModel.value);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.isLabelPositionToEnd && __props.label)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass({ 'disable-label': __props.readOnly })
        }, _toDisplayString(__props.label), 3))
      : _createCommentVNode("", true),
    _createVNode(_unref(DxSwitch), {
      value: dxSwitchValue.value,
      onValueChanged: onChange,
      disabled: props.readOnly
    }, null, 8, ["value", "disabled"]),
    (props.readOnly && __props.displayLockIcon)
      ? (_openBlock(), _createElementBlock("i", _hoisted_2))
      : _createCommentVNode("", true),
    (__props.isLabelPositionToEnd && __props.label)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: _normalizeClass({ 'disable-label': __props.readOnly })
        }, _toDisplayString(__props.label), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})